export const MODALIZE_ANIMATION_DURATION = 500;
